import { createStore } from 'devextreme-aspnet-data-nojquery';

import { applyBearerAuthHeader } from './auth-token';
import { isBearerAuthMode } from './auth-mode';
import { getApiBaseUrl } from './runtime-urls';

type Params = {
  pageSize?: number;
  paginate?: boolean;
  defaultFilter?: Array<any>;
  defaultSort?: Array<any>;
};

const initialParams = {
  pageSize: 100,
  paginate: true,
  defaultFilter: [],
  defaultSort: [],
};

const $createStore = <T>(url: string, key: string, params: Params = initialParams, callBack?: (data: T[]) => void) => {
  const filter = params.defaultFilter?.length ? JSON.stringify(params.defaultFilter) : '';

  return createStore({
    key: key,
    //group: group ? group : null,
    loadUrl: `${getApiBaseUrl()}${url}`,
    onBeforeSend: (method, ajaxOptions) => {
      let newFilter = ajaxOptions.data.filter ? ajaxOptions.data.filter : '';
      let newDefaultFilter = params.defaultFilter?.length ? JSON.stringify(params.defaultFilter) : '';
      const hasAmp = newFilter && newDefaultFilter ? ',"and",' : '';
      newFilter = newFilter + hasAmp + filter;
      ajaxOptions.data.filter = newFilter;
      if (isBearerAuthMode()) {
        ajaxOptions.headers ??= {};
        applyBearerAuthHeader(ajaxOptions.headers as Record<string, string | undefined>);
      } else {
        ajaxOptions.xhrFields = { withCredentials: true };
      }
    },
    //loadMode: 'raw',
    updateUrl: `${getApiBaseUrl()}${url}`,
    onLoaded: (result: Array<T>) => {
      if (callBack) callBack(result);
    },
    onAjaxError(e) {
      if (e.xhr.status === 401) {
        window.location.hash = 'logout-auth';
      }
    },
  });
};

export default $createStore;
